// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_CarregaidiomasResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for carregaIdiomas endpoint.
 * Returns an array of available languages from the translations service.
 * Proxy to translations-service GET /languages/list — each row mirrors the
 * Language entity in services/translations-service/src/persistentdata/languages/entity.go.
 */
import type { Usuarios_CarregaidiomasRow } from './Usuarios_CarregaidiomasRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Usuarios_CarregaidiomasResponseDados = Usuarios_CarregaidiomasRow[];

export type Usuarios_CarregaidiomasResponse = ApiResponse<Usuarios_CarregaidiomasResponseDados>;

registerResponseContract('Usuarios_CarregaidiomasResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      id:          { type: 'string',  required: true },
      name:        { type: 'string',  required: true },
      description: { type: 'string',  required: false },
      created_at:  { type: 'string',  required: false },
      updated_at:  { type: 'string',  required: false },
      deleted_at:  { type: 'string',  required: false },
    },
  },
})
